export default "__VITE_PUBLIC_ASSET__d6f27402__"